import theme from "../../theme";
import type { ImageCaptureStyles } from "../../types";
import type { SxProps, Theme } from "@mui/material";

const getStyles = (): Record<ImageCaptureStyles, SxProps<Theme>> => {
  return {
    mobileRoot: {
      display: "flex",
      justifyContent: "space-around",
      position: "fixed",
      bottom: 0,
      bgcolor: "#fff",
      width: "100%",
    },

    webcamWrapper: {
      backgroundColor: "#FFFFFF",
      m: "0 auto",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      position: "absolute",
      overflow: "hidden",
      left: "50%",
      [theme.breakpoints.up("md")]: {
        borderRadius: "30px",
        transform: "translate(-50%)",
        top: "8px",
      },
      [theme.breakpoints.down("md")]: {
        transform: "translate(-50%, -50%)",
        top: "50%",
        height: "100%",
        width: "100%",
      },
    },

    selfieGuideline: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      boxShadow: "0 0 0 500px rgba(0, 0, 0, 0.8)",
      borderRadius: "50%",
      border: "none",
      [theme.breakpoints.up("md")]: {
        height: "70%",
        width: "30%",
      },
      [theme.breakpoints.down("md")]: {
        height: "45%",
        width: "45%",
      },
      [theme.breakpoints.only("xs")]: {
        height: "70%",
        width: "90%",
      },
    },

    documentGuideline: {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: "translate(-50%, -50%)",
      [theme.breakpoints.up("md")]: {
        height: "70%",
        width: "70%",
        border: "none",
        boxShadow: "0 0 0 500px rgba(0, 0, 0, 0.8)",
      },
      [theme.breakpoints.down("md")]: {
        height: "70%",
        width: "90%",
        border: "none",
        boxShadow: "0 0 0 500px rgba(0, 0, 0, 0.8)",
      },
    },

    desktopExit: {
      position: "fixed",
      top: 0,
      right: 0,
      color: "#fff",
    },

    desktopCapture: {
      width: "30%",
      position: "absolute",
      bottom: 10,
    },

    dialogBase: {
      backgroundColor: "#333",
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundPosition: "center",
      maxWidth: "100%",
      maxHeight: "100%",
      width: "100%",
      height: "100%",
      justifyContent: "space-between",
      m: 0,
    },

    dialogTitle: { textAlign: "center", color: "white" },

    dialogText: {
      fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
      [theme.breakpoints.up("sm")]: {
        fontSize: "60px",
        lineHeight: "1.2",
        letterSpacing: "-0.00833em",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "1.6",
        letterSpacing: "0.0075em",
      },
    },

    errorText: {
      fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
      [theme.breakpoints.up("sm")]: {
        fontSize: "40px",
        lineHeight: "1.2",
        letterSpacing: "-0.00833em",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "1.6",
        letterSpacing: "0.0075em",
      },
    },

    dontGiveUpText: {
      [theme.breakpoints.up("sm")]: {
        fontSize: "80px",
        fontWeight: "500",
        lineHeight: "1.2",
        letterSpacing: "-0.00833em",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "40px",
        fontWeight: "700",
        lineHeight: "1.6",
        letterSpacing: "0.0075em",
      },
    },

    dialogActions: {
      justifyContent: "space-around",
      flexDirection: "column",
      color: "white",
      gap: "30px",
      textAlign: "center",
    },

    dialogCaption: {
      fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
      [theme.breakpoints.up("sm")]: {
        fontSize: "20px",
        fontWeight: "500",
        lineHeight: "1.6",
        letterSpacing: "0.0075em",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "1.66",
        letterSpacing: "0.03333em",
      },
    },

    continue: {
      [theme.breakpoints.up("sm")]: {
        width: "50%",
        fontSize: "25px",
      },
      [theme.breakpoints.down("sm")]: {
        width: "75%",
        fontSize: "20px",
      },
    },

    errorIcon: {
      alignSelf: "center",
      color: "#fff",
      [theme.breakpoints.up("sm")]: {
        fontSize: "200px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "100px",
      },
    },

    approvalImage: {
      m: "0 auto",
      [theme.breakpoints.up("sm")]: {
        maxHeight: "60%",
      },
      [theme.breakpoints.down("sm")]: {
        maxHeight: "50%",
      },
    },
  };
};

export default getStyles;
